"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// import { AppAnalyticsEvent, AppSDKManager } from '@sales/analytics';
var ReportingService_1 = require("./ReportingService");
var ui_frameworks_components_analytics_event_1 = require("@att-bit/ui-frameworks.components.analytics-event");
var CommonUtilFuntions_1 = require("../utils/CommonUtilFuntions");
/**
 * Any reporting call should fire through this Class further.
 */
var ReportingGateway = /** @class */ (function () {
    function ReportingGateway() {
    }
    /* static reportEvent(appAnalyticsEvent: AppAnalyticsEvent) {
        ReportingGateway.filterLinkAttributesForSystemEvent(appAnalyticsEvent);
        ReportingGateway.filterAttributesForFormSubmitEvent(appAnalyticsEvent);
        AppSDKManager.reportEvent(appAnalyticsEvent);
    } */
    /**
     * This filter method make sure that if eventAction is SystemEvent
     * It should not report the following parameters at all
     * linkName
     * linkDestinationUrl
     * linkPosition
     * @param appAnalyticsEvent
     */
    ReportingGateway.filterLinkAttributesForSystemEvent = function (appAnalyticsEvent) {
        if (appAnalyticsEvent.eventAction && appAnalyticsEvent.eventAction === ReportingService_1.EventTypesCodes.SYSTEM_EVENT) {
            if (appAnalyticsEvent && appAnalyticsEvent.additionalData) {
                // tslint:disable-next-line:no-any
                var data = appAnalyticsEvent.additionalData;
                if (appAnalyticsEvent.additionalData.hasOwnProperty('linkName')) {
                    delete data.linkName;
                }
                if (data.hasOwnProperty('linkDestinationUrl')) {
                    delete data.linkDestinationUrl;
                }
                if (data.hasOwnProperty('linkPosition')) {
                    delete data.linkPosition;
                }
            }
        }
    };
    ReportingGateway.filterAttributesForFormSubmitEvent = function (appAnalyticsEvent) {
        if (appAnalyticsEvent.eventAction && appAnalyticsEvent.eventAction === ReportingService_1.EventTypesCodes.FORM_SUBMIT_EVENT) {
            if (appAnalyticsEvent && appAnalyticsEvent.additionalData) {
                // tslint:disable-next-line:no-any
                var data = appAnalyticsEvent.additionalData;
                if (data.hasOwnProperty('successFlag')) {
                    data.successFlag = '-2';
                }
                if (appAnalyticsEvent.additionalData.hasOwnProperty('statusMessage')) {
                    delete data.statusMessage;
                }
            }
        }
    };
    ReportingGateway.sendReportingEvent = function (analyticsEvent) {
        // console.log('Reporting event data', analyticsEvent);
        try {
            CommonUtilFuntions_1.docComplete(function () {
                ReportingGateway.filterLinkAttributesForSystemEvent(analyticsEvent);
                ReportingGateway.filterAttributesForFormSubmitEvent(analyticsEvent);
                ui_frameworks_components_analytics_event_1.AnalyticsEvent(analyticsEvent);
            });
        }
        catch (e) {
            console.log('test new analytics page', e);
        }
    };
    return ReportingGateway;
}());
exports.default = ReportingGateway;
//# sourceMappingURL=ReportingGateway.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/api/ReportingGateway.js
// module id = 1437
// module chunks = 8